import { ADD_GOAL, REMOVE_GOAL } from './types';
import { PROPERTIES } from '../utilities';

export const addGoal = (square) => {
  var goal = PROPERTIES.map(prop => square[prop] !== undefined ? square[prop] : '.').join('/');
  return {
    type : ADD_GOAL,
    payload : goal
  }
}

export const removeGoal = () => {
  return { type : REMOVE_GOAL };
}



// WEBPACK FOOTER //
// ./src/actions/goals.js